import React, { Component } from "react";
import { Button, Col, DatePicker, Form, Input, Row, Spin } from "antd";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import dayjs from "dayjs";
import EventStore from "../store/EventStore";
import ReactQuill from "react-quill";

const modules = {
  toolbar: [
    [{ font: [] }, { size: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ header: [1, 2, 3, 4, 5, 6] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["image"],
  ],
};

const formats = [
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "header",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "align",
  "image",
];
class EventAdd extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loadingSpin: false,
      id: -1,
      content: "",
    };

    this.eventStore = new EventStore(this);
  }

  async componentDidMount() {
    const id = this.props.id;

    if (id) {
      await this.filldata(id);
    }

    this.setState({ update: 1 });
  }

  async filldata(id) {
    const getEventData = await this.eventStore.getEventData(id);

    this.setState({ id: getEventData.id, content: getEventData.content || "" });

    this.formRef.current.setFieldsValue({
      title: getEventData.title,
      expiryDate: getEventData.expiryDate
        ? dayjs(getEventData.expiryDate)
        : null,
      content: getEventData.content,
    });
  }

  onEventDetailSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      id: this.state.id,
      content: this.state.content,
      expiryDate: fieldsValue.expiryDate
        ? fieldsValue.expiryDate.format("YYYY-MM-DD")
        : "",
      type: 1,
      userId: this.props.getUserData().userId,
    };

    this.setState({ loading: true });
    const response = await this.eventStore.addData(data);
    await this.props.response(response);

    this.setState({ loading: false });
  };

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
  }

  closeModal = () => {
    this.props.closeModal();
  };

  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Spin
            wrapperClassName="spinClass"
            spinning={this.state.loadingSpin}
            fullscreen
          >
            <Form
              ref={this.formRef}
              layout="vertical"
              name="nest-messages"
              onFinish={this.onEventDetailSubmit}
              style={{ maxWidth: "100%", padding: 0 }}
              className="formClass"
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="formColumnClass">
                  <Form.Item
                    name="title"
                    // label={this.context.translate("_TITLE_")}
                    // rules={[{ required: true }]}

                    label={
                      <span>
                        {this.context.translate("_TITLE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_TITLE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={12} className="formColumnClass">
                  <Form.Item
                    name="expiryDate"
                    // label={this.context.translate("_EXPIRY_DATE_")}
                    // rules={[{ required: true }]}

                    label={
                      <span>
                        {this.context.translate("_EXPIRY_DATE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_EXPIRY_DATE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <DatePicker
                      format="YYYY-MM-DD"
                      style={{ width: "100%", height: "40px" }}
                      disabledDate={(current) => {
                        return current && current < dayjs();
                      }}
                    />
                  </Form.Item>
                </Col>

                <Row>
                  <Form.Item name="content">
                    <div className="quill-editor-container">
                      <ReactQuill
                        value={this.state.content}
                        onChange={(value) => this.setState({ content: value })}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </Form.Item>
                </Row>
              </Row>

              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={() => this.closeModal()}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button
                  htmlType="submit"
                  loading={this.state.loading}
                  className="formsSaveButton"
                >
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                </Button>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    );
  }
}

EventAdd.contextType = StoreContext;
export default observer(withRouter(EventAdd));
